import React from "react";
import { Colors } from "../constants/colors";

function TermsAndConditions() {
    return (
        <div style={styles.page}>
            <div style={styles.content}>
                <h1 style={styles.centerText}>Terms & Conditions</h1>
                <p style={styles.centerText}>Last Updated: November 01, 2025</p>

                <p>
                    Welcome to <strong>Naryi</strong>! By using our mobile app, you agree to these Terms & Conditions. Please read them carefully.
                </p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                    <strong>1.1</strong> By downloading or using Naryi, you agree to be bound by these Terms & Conditions, our <a href="/privacy" style={styles.link}>Privacy Policy</a>, and all applicable laws. If you do not agree, do not use the app.
                </p>

                <h2>2. Eligibility</h2>
                <p>
                    <strong>2.1</strong> Naryi is intended for users aged 13 and older. By using our services, you confirm that you meet this age requirement. Users under 18 must have parental consent.
                </p>

                <h2>3. Account Registration</h2>
                <ul style={styles.list}>
                    <li>You may need to create an account to use certain features.</li>
                    <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                    <li>You agree to provide accurate and complete information during registration.</li>
                </ul>

                <h2>4. Use of Naryi</h2>
                <ul style={styles.list}>
                    <li>You may use the app only for lawful purposes.</li>
                    <li>You agree not to misuse or disrupt the app, including hacking or interfering with other users’ data.</li>
                    <li>We reserve the right to suspend or terminate your access if you violate these Terms.</li>
                </ul>

                <h2>5. Student Data Usage</h2>
                <p>
                    <strong>5.1</strong> Naryi allows students to optionally import class schedules or other academic data to help manage screen time and focus habits.
                </p>
                <p>
                    <strong>5.2</strong> Importing this information is voluntary. We store this data securely in our database and may use it in an aggregated, anonymized form to analyze trends and improve the app experience.
                </p>
                <p>
                    <strong>5.3</strong> Your individual schedules are never shared with advertisers or sold. You remain in control and can delete your imported schedules at any time within the app.
                </p>

                <h2>6. Intellectual Property</h2>
                <p>
                    <strong>6.1</strong> All content in Naryi, including text, graphics, logos, and software, is our property or used under license. You may not copy, reproduce, or distribute any content without prior written consent.
                </p>

                <h2>7. Limitation of Liability</h2>
                <p>
                    <strong>7.1</strong> Naryi is provided "as is" and without warranties of any kind. We are not responsible for damages arising from your use of the app, including data loss, errors, or interruptions.
                </p>

                <h2>8. Changes to Terms</h2>
                <p>
                    <strong>8.1</strong> We may update these Terms & Conditions from time to time. Changes will be reflected with a revised date at the top. Continued use constitutes acceptance of the updated terms.
                </p>

                <h2>9. Governing Law</h2>
                <p>
                    <strong>9.1</strong> These Terms are governed by the laws of the United States and the state in which Naryi operates, without regard to conflict of law provisions.
                </p>

                <h2>10. End-User License Agreement (EULA)</h2>
                <p>
                    <strong>10.1</strong> This EULA is a legal agreement between you (the "End User") and Naryi ("Company") regarding your use of the Naryi mobile application.
                </p>
                <ul style={styles.list}>
                    <li><strong>License Grant:</strong> Naryi grants a limited, non-exclusive, non-transferable, revocable license to use the app for personal, non-commercial purposes.</li>
                    <li><strong>Restrictions:</strong> You may not modify, distribute, sell, reverse engineer, or create derivative works from Naryi.</li>
                    <li><strong>Ownership:</strong> The app and all content remain the property of Naryi. No ownership rights are transferred to you.</li>
                    <li><strong>Termination:</strong> Naryi may terminate or suspend your license if you violate the EULA. Upon termination, you must uninstall and delete the app.</li>
                    <li><strong>Disclaimer:</strong> Naryi is provided "as is." The Company disclaims all warranties, express or implied, including fitness for a particular purpose.</li>
                    <li><strong>Limitation of Liability:</strong> Naryi is not liable for any damages arising from use or inability to use the app.</li>
                </ul>

                <h2>11. Contact Us</h2>
                <p>
                    <strong>11.1</strong> Questions or concerns about these Terms or the EULA? Contact us at <a href="mailto:support@naryi.com" style={styles.link}>support@naryi.com</a> or visit <a href="https://www.naryi.com/contact-us" style={styles.link}>www.naryi.com/contact-us</a>.
                </p>
            </div>
        </div>
    );
}

const styles = {
    page: {
        padding: "3rem 1.5rem",
        fontFamily: "system-ui, sans-serif",
        lineHeight: "1.6",
        color: "#333",
        display: "flex",
        backgroundColor: Colors.background.light,
        justifyContent: "center",
    },
    content: {
        maxWidth: "700px",
        textAlign: "left",
    },
    centerText: {
        textAlign: "center",
    },
    list: {
        textAlign: "left",
        margin: "1rem 0",
        paddingLeft: "1.5rem",
    },
    link: {
        color: "#000", // black links
        textDecoration: "underline", // optional
    },
};

export default TermsAndConditions;
